import type { EmailRule, EmailRuleCondition } from './useData';
import { WORKFLOW_STATUS_OPTIONS } from './config';

export function formatConditionLabel(cond: EmailRuleCondition): string {
  const field =
    cond.field === 'from'
      ? 'From'
      : cond.field === 'to'
        ? 'To'
        : cond.field === 'subject'
          ? 'Subject'
          : cond.field === 'body'
            ? 'Body'
            : 'Folder';
  const op =
    cond.operator === 'contains'
      ? 'contains'
      : cond.operator === 'equals'
        ? 'is'
        : cond.operator === 'startsWith'
          ? 'starts with'
          : 'ends with';
  const value = cond.value.trim() || '…';
  return `${field} ${op} "${value}"`;
}

export function formatActionLabel(
  action: EmailRule['actions']['actions'][number],
  personalFolderNames: Map<number, string>,
  userNames: Map<number, string>,
): string {
  switch (action.type) {
    case 'copyToFolder':
      if ('personalFolderId' in action && typeof action.personalFolderId === 'number') {
        const name = personalFolderNames.get(action.personalFolderId);
        return name ? `Copy to ${name}` : `Copy to folder #${action.personalFolderId}`;
      }
      if ('folder' in action && typeof action.folder === 'string') {
        return `Copy to ${action.folder}`;
      }
      return 'Copy to folder';
    case 'moveToFolder':
      return action.folder.toUpperCase() === 'JUNK' ? 'Move to Junk' : `Move to ${action.folder}`;
    case 'markRead':
      return 'Mark as read';
    case 'addTag':
      return `Tag: ${action.tagName}`;
    case 'assignUser': {
      const name = userNames.get(action.assignedToUserId);
      return name ? `Assign to ${name}` : `Assign to user #${action.assignedToUserId}`;
    }
    case 'setWorkflowStatus': {
      const label =
        WORKFLOW_STATUS_OPTIONS.find((option) => option.value === action.workflowStatus)?.label ??
        action.workflowStatus;
      return `Set status: ${label}`;
    }
    default:
      if ((action as { type: string }).type === 'blockSender') {
        return 'Move to Junk';
      }
      return 'Action';
  }
}

export function formatMatchLabel(match: EmailRule['conditions']['match']): string {
  return match === 'any' ? 'Match any' : 'Match all';
}
